let currentUrlState = sanitizeUrl(window.location.href);

/**
 * Sets the values of specified URL parameters as cookies.
 * If a cookie already exists with a different value, it will be updated with the new value.
 *
 * @param {Array<string>} urlParamsCaptureList - An array of URL parameter names to capture and set as cookies.
 * @param {number} expiration  - The number of days until the cookies expire (default:30).
 */
function setURLParamsAsCookies(urlParamsCaptureList, expiration = 30) {
	const urlParams = new URLSearchParams(currentUrlState.split('?')[1] || '');
	for (const [key, value] of urlParams.entries()) {
		if (urlParamsCaptureList.includes(key)) {
			const existingCookieValue = utilFetchCookieValue(key);
			if (value && (!existingCookieValue || existingCookieValue !== value)) {
				document.cookie = `${key}=${value};expires=${new Date(Date.now() + expiration * 24 * 60 * 60 * 1000)};path=/`;
			}
		}
	}
}

function setAllURLParamsAsCookies(expiration = 30) {
	const urlParams = new URLSearchParams(currentUrlState.split('?')[1] || '');
	for (const [key, value] of urlParams.entries()) {
		if (value && utilFetchCookieValue(key) != value) {
			document.cookie = `${key}=${value};expires=${new Date(Date.now() + expiration * 24 * 60 * 60 * 1000)};path=/`;
		}
	}
}

/**
 * Sets the values of specified UTM from the target URL as cookies.
 * If a cookie already exists with a different value, it will be updated with the new value,
 * and non-existing cookies will be removed.
 *
 * @param {Array<string>} urlParamsCaptureList - An array of URL parameter names to capture and set as cookies.
 * @param {number} expiration - The number of days until the cookies expire (default: 30).
 */
function setUTMParamsAsCookies(urlParamsCaptureList, expiration = 30) {
	const urlParams = new URLSearchParams(currentUrlState.split('?')[1] || '');
	if (urlParamsCaptureList.some((e) => Array.from(urlParams.keys()).includes(e))) {
	  urlParamsCaptureList.forEach((key) => {
		if (urlParams.has(key)) {
		  const existingCookieValue = utilFetchCookieValue(key);
		  const newCookieValue = urlParams.get(key);
		  if (newCookieValue && (!existingCookieValue || existingCookieValue !== newCookieValue)) {
			document.cookie = `${key}=${newCookieValue};expires=${new Date(
			  Date.now() + expiration * 24 * 60 * 60 * 1000
			)};path=/`;
		  }
		} else {
		  if (utilFetchCookieValue(key)) {
			utilDeleteCookie(key);
		  }
		}
	  });
	}
	captureAffiliateData();
}

/**
 * Captures the affiliation params from the utm cookies
 * @return {void}
 */

function captureAffiliateData(){
	const affiliateProviders = ['rakuten','ShareASale','CJ','refersion'];
	if(utilFetchCookieValue('utm_source') &&  affiliateProviders.some(p=>p.toLowerCase() === utilFetchCookieValue('utm_source').toLowerCase()) && utilFetchCookieValue('utm_campaign')){
		utilSetCookie('affiliate_id',utilFetchCookieValue('utm_campaign'),30);
		utilSetCookie('affiliate_data',utilFetchCookieValue('landing_url'),30);
	}
}

function sanitizeUrl(url=""){
	let fixedUrl = url;
	const urlParts = url.split('?');
	if(urlParts.length > 2){
		urlParts.forEach((p,i)=>{
			if(i===0){
				fixedUrl = p;
			}
			if(i===1){
				fixedUrl += `?${p}`;
			}
			if(i>1){
				fixedUrl += `&${p}`;
			}
		})
	}
	return mapUTMParametersFromTw(fixedUrl);
}

function mapUTMParametersFromTw(url=''){
	let urlSegments = url.split('?');
	let formattedUrl = url;
	if(urlSegments.length > 1){
		const urlParams = urlSegments[1].split('&');
		const modifiedParams = urlParams.map(p=>{
			let [key,value] = p.split('=');
			if(key.includes('utm_') && (value == '' || value == null) && urlParams.some(param => param.startsWith(`tw_${key.substring(4)}`))){
				let twAlterNativeKey = `tw_${key.substring(4)}`;
				let twAlternativeValue = urlParams.find(param => param.startsWith(twAlterNativeKey)).split('=')[1];
				return `${key}=${twAlternativeValue}`;
			}
			return p;
		});
		// Check for "tw_" parameters without corresponding "utm_" parameters
		urlParams.forEach(p => {
			let [key, value] = p.split('=');
			if (key.startsWith('tw_') && !urlParams.some(param => param.startsWith(`utm_${key.substring(3)}`))) {
				modifiedParams.push(`utm_${key.substring(3)}=${value}`);
			}
		});
		formattedUrl = `${urlSegments[0]}?${modifiedParams.join('&')}`;
	}
	return formattedUrl;
}

/**
 * Retrieves the value of a single cookie.
 *
 * @param {string} key - The name of the cookie to retrieve.
 * @returns {string|null} The value of the cookie, or null if the cookie does not exist.
 */
function utilFetchCookieValue(key) {
	const name = `${key}=`;
	const cookies = document.cookie.split(";");
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();
		if (cookie.startsWith(name)) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return null;
}

/**
 * Retrieves the values of multiple cookies.
 *
 * @param {Array<string>} keys - An array of cookie names to retrieve.
 * @returns {Object} An object containing the name-value pairs of the specified cookies.
 */
function utilFetchCookieValues(keys) {
	const cookies = document.cookie.split(";");
	const values = {};

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();
		for (let j = 0; j < keys.length; j++) {
			const name = `${keys[j]}=`;
			if (cookie.startsWith(name)) {
				values[keys[j]] = cookie.substring(name.length, cookie.length);
				break;
			}
		}
	}
	return values;
}

/**
 * Set a cookie with the given key, value, and expiration in days.
 *
 * @param {string} key - Name of the cookie key.
 * @param {string} value - Value to be set for the cookie.
 * @param {number} expiration - Number of days until the cookie expires.
 */
function utilSetCookie(key, value, expiration) {
	let expirationDate = new Date(Date.now() + expiration * 24 * 60 * 60 * 1000);
	document.cookie = `${key}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
}

/**
 * Update a cookie with the given key name
 * @param {string} key - Name of the cookie key
 * @param {string} value - Value to be set for the cookie
 * @param {number} [expiration=30] - Expiration time for the cookie in days (default: 30)
 */
function utilUpdateCookie(key, value, expiration = 30) {
	let existingValue = utilFetchCookieValue(key);
	if (existingValue !== value) {
		document.cookie = `${key}=${value};expires=${new Date(Date.now() + expiration * 24 * 60 * 60 * 1000)};path=/`;
	}
}

/**
 * Delete a cookie with the given key name
 * @param {string} key - Name of the cookie key
 */
function utilDeleteCookie(key) {
	document.cookie = `${key}=;expires=${new Date(0)};path=/`;
}

function utilGetLatestClickID() {
	const keysToCheck = ["gclid", "fbclid", "msclkid"];
	let latestClickID = null;
	let platform = null;

	// Get all cookies
	const cookies = document.cookie.split("; ");

	// Iterate through cookies
	cookies.forEach((cookie) => {
		const [name, value] = cookie.split("=");

		// Check if the cookie name is one of the keys we're interested in
		if (keysToCheck.includes(name)) {
			// Check if it's the latest click ID found so far
			if (!latestClickID) {
				latestClickID = { name, value };
				if (name === "gclid") {
					platform = "google";
				} else if (name === "fbclid") {
					platform = "facebook";
				} else if (name === "msclkid") {
					platform = "bing";
				}
			} else {
				// Compare the timestamp of the current and latest click IDs if available
				const currentValue = decodeURIComponent(value);
				const currentTimestamp = parseFloat(currentValue.split("_")[1]);
				const latestTimestamp = parseFloat(latestClickID.value.split("_")[1]);

				if (!isNaN(currentTimestamp) && !isNaN(latestTimestamp) && currentTimestamp > latestTimestamp) {
					latestClickID = { name, value };
					if (name === "gclid") {
						platform = "google";
					} else if (name === "fbclid") {
						platform = "facebook";
					} else if (name === "msclkid") {
						platform = "bing";
					}
				}
			}
		}
	});

	// Check if any click ID was found, if not, return null
	if (!latestClickID) {
		return null;
	}

	return { clickID: latestClickID, platform };
}